import { render, staticRenderFns } from "./orangelogin.vue?vue&type=template&id=466213ff&scoped=true"
import script from "./orangelogin.vue?vue&type=script&lang=js"
export * from "./orangelogin.vue?vue&type=script&lang=js"
import style0 from "./orangelogin.vue?vue&type=style&index=0&id=466213ff&prod&lang=css"
import style1 from "./orangelogin.vue?vue&type=style&index=1&id=466213ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466213ff",
  null
  
)

export default component.exports